import React from 'react';
import { Icon } from '@iconify/react';
import tailwindcssIcon from '@iconify/icons-logos/tailwindcss-icon';
import reactjsIcon from '@iconify/icons-logos/react';
import { HighlightedTextIcon } from 'components/molecules';

const Text = () => (
    <>
        J'ai passé environ deux ans à améliorer mes compétences en{' '}
        <span className="font-bold text-gray-800">développement de sites web</span> en utilisant{' '}
        <HighlightedTextIcon
            as="a"
            href="https://reactjs.org"
            className="mx-2"
            icon={<Icon icon={reactjsIcon} />}
        >
            ReactJS
        </HighlightedTextIcon>{' '}
        et{' '}
        <HighlightedTextIcon className="mx-2" icon={<Icon icon={tailwindcssIcon} />}>
            TailwindCSS
        </HighlightedTextIcon>{' '}
        et je suis maintenant assez confiant pour construire des applications avec ces outils :
    </>
);

const skills = {
    text: <Text />,
};

export default skills;
